"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWebsocketEffect = void 0;
const react_1 = require("react");
const web_socket_context_1 = require("./web-socket-context");
/**
 * Enhanced useEffect.
 *
 * Executed when received message from server is found in deps.
 *
 * @param effect
 * @param deps
 */
function useWebsocketEffect(effect, deps) {
    const { message, setMessage } = (0, react_1.useContext)(web_socket_context_1.WebsocketContext);
    (0, react_1.useEffect)(() => {
        if (deps.includes(message)) {
            setMessage('');
            return effect();
        }
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [message]);
}
exports.useWebsocketEffect = useWebsocketEffect;
//# sourceMappingURL=web-socket-effect-hook.js.map